export { default } from './IntakeSegmentRow';
